module.exports = __webpack_public_path__ + "static/media/rasmus.d53b8af5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/members/rasmus.jpg
// module id = 51
// module chunks = 0